import { em, math } from 'polished'
import styled from 'styled-components'

import { BoxBase, RowIndented } from 'styles/components/layout'

export const BoxBaseStyled = styled(BoxBase)`
  position: relative;
  margin-bottom: ${p =>
    p.isRu ? 0 : math(`${p.theme.buttons.hActionBtn} / 2`)};
  z-index: 2;

  ${p => p.theme.mq.upMd} {
    margin-top: 20px;
  }

  ${p => p.theme.mq.upLg} {
    margin-top: 40px;
  }
`

export const RowIndentedStyled = styled(RowIndented)`
  background: ${props =>
    props.isBlackBg
      ? p => p.theme.colors.mineShaft
      : p => p.theme.colors.grayOp06NonTransp};
  padding-bottom: ${p => (p.isRu ? em(26) : '2.5em')};
  padding-top: ${p => (p.isRu ? em(26) : '1.25em')};

  ${p => p.theme.mq.upMd} {
    border-radius: ${p => p.theme.blocks.blockBorderRadiusMedium};
    padding-top: 1.25em;
    padding-bottom: 2.5em;
  }

  ${p => p.theme.mq.upLg} {
    padding-top: ${p => (p.isRu ? em(26) : '2.5em')};
  }
`

export const ButtonBlock = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  transform: translateY(50%);
  text-align: center;
`
